import React from 'react';
import { useNav } from '../../hx/useNav';
import { useTranslation } from '../../hx/useTranslation';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import { clearStore, StoreSettCertificate } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import GxList from '../../gx/GxList';


const MxSettCertificateList = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navTo }] = useNav();

  const [storeSettCertificate, setStoreSettCertificate] = useSessionStorage('StoreSettCertificate', StoreSettCertificate);

  React.useEffect(() => {
    clearStore('StoreSettCertificate', storeSettCertificate);
    formLoad();
    // eslint-disable-next-line
  }, []);

  const formLoad = async () => {
  }

  const openForm = async (op, row) => {
    storeSettCertificate.certificateType = 'E';
    if (row === null) {
      storeSettCertificate.title = `${trans('field.new_1')}`;
      storeSettCertificate.itCertificate = null;
    } else {
      storeSettCertificate.title = row.original.txEmployee;
      storeSettCertificate.itCertificate = row.original.itCertificate;
    }
    setStoreSettCertificate(storeSettCertificate);
    navTo("sett-certificate-form");
  }

  return (
    <div>
      <GxList
        moduleName={`${trans('field.certificates')}`}
        fullscreen
        hasSearchBox={false}
        url="sett/certificate"
        onOpenForm={openForm}
        columns={[
          { id: "0", Header: "ID", accessor: "itCertificate", show: false },
          { id: "1", Header: `${trans('field.employee')}`, accessor: "txEmployee", width: '100%' },
        ]}
      />
    </div>
  );
}

export default MxSettCertificateList;
